// extracted by mini-css-extract-plugin
module.exports = {"mulitpleDropdown":"cardFooterItem_mulitpleDropdown__1w6BF","footerTextWithIcon":"cardFooterItem_footerTextWithIcon__29_wt"};